import { logger } from "./logger";

const getItem = (key: string) => {
  const localItem = localStorage.getItem(key);
  try {
    if (localItem) return JSON.parse(localItem);
  } catch (e) {
    logger.error(e);
  }
  return null;
};

const setItem = <T>(value: T, key: string) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    logger.error(e);
  }
};

export const customLocalStorage = {
  get grammar() {
    return getItem("grammar");
  },
  setGrammar: (grammar: Grammar) => setItem(grammar, "grammar"),

  get lastStateRefreshDate() {
    return getItem("lastStateRefreshDate");
  },
  setLastStateRefreshDate: (lastStateRefreshDate: string) => setItem(lastStateRefreshDate, "lastStateRefreshDate"),

  setCorpora: (corpora: Corpus[]) => setItem(corpora, "corpora"),
  get corpora() {
    return getItem("corpora");
  },
};
